import {
  TranslationResult,
  ApiResponse
} from '../shared/types';
import { 
  translationCache
} from '../utils/localStorage';
import { clientTranslationService } from './clientTranslationService';

class ApiError extends Error {
  constructor(public status: number, message: string, public details?: any) {
    super(message);
    this.name = 'ApiError';
  }
}

export const slangApi = {
  async translate(phrase: string): Promise<TranslationResult> {
    const cacheKey = phrase.toLowerCase().trim();
    
    // Check cache first
    const cachedData = translationCache.get(cacheKey) as TranslationResult | null;
    if (cachedData) {
      console.log('API: Serving from cache', phrase);
      return cachedData;
    }

    try {
      // Use client-side translation service
      const result = await clientTranslationService.translate(phrase);
      
      // Cache the result
      translationCache.set(cacheKey, result);
      
      return result;
    } catch (error) {
      throw new ApiError(
        500,
        error instanceof Error ? error.message : 'Translation failed'
      );
    }
  },

  async getSuggestions(query: string): Promise<string[]> {
    try {
      // Use client-side suggestion service
      return await clientTranslationService.getSuggestions(query);
    } catch (error) {
      console.error('Error getting suggestions:', error);
      return [];
    }
  },
};

export { ApiError };